const ar = {
  error404: {
    title: "404 - الصفحة غير موجودة | QRHUB",
    description: "الصفحة التي تبحث عنها غير موجودة.",
    errorNumber: "404",
    errorTitle: "عذراً، الصفحة غير موجودة",
    errorDescription:
      "يبدو أنك ضللت الطريق، أو أن المحتوى الذي تبحث عنه لم يعد متاحاً",
    goBackHome: "العودة للصفحة الرئيسية",
  },

  // Meno page
  nav: {
    features: "المميزات",
    howItWorks: "طريقة العمل",
    pricing: "الأسعار",
    faq: "الأسئلة الشائعة",
    startFreeTrial: "ابدأ تجربتك المجانية",
    needHelp: "حاجة لمساعدة؟",
  },
  hero: {
    badge: "من QRHUB",
    headline1: "القائمة الرقمية",
    headline2: "التي تحقق لك",
    headline3: "طلبات",
    headlineAccent: "فعليّة.",
    sub: "لا تكتفِ بعرض قائمتك، ابدأ البيع من خلالها. أنشئ قائمة رقمية تفاعلية، أدر جميع فروعك، واستقبل الطلبات مباشرة عبر واتساب.",
    mockupAlt: "قائمة مطعم Risotto Vero معروضة على منصة Meno للطلب الرقمي",
    cta: "ابدأ الآن مجاناً",
    ctaSecondary: "طريقة العمل",
    trial: "تجربة مجانية لمدة 30 يوم.",
  },
  businessType: {
    titleFirst: "صُمم",
    titleSecond: "جاهز",
    titleThird: "  للمطاعم.",
    titleFourth: "  للمنتجات.",
    sub: "سواء كنت تبيع طعاماً أو منتجات ، يساعدك MENO على عرضها ومشاركتها واستقبال الطلبات مباشرة عبر واتساب.",
    toggleFood: "قائمة طعام",
    toggleProducts: "قائمة منتجات",
    food: {
      badge: "قائمة طعام",
      title1: "قائمتك، جاهزة",
      title2: "لاستقبال الطلبات.",
      desc: "أنشئ قائمة رقمية لمطعمك أو مقهاك أو مطبخك السحابي أو مخبزك أو مشروع الطعام المنزلي. شارك رابطاً واحداً أو رمز QR، ودع العملاء يتصفحون أصنافك، يضيفون للسلة، ويرسلون طلبهم مباشرة إلى واتساب.",
      tag1: "المطاعم",
      tag2: "المقاهي",
      tag3: "مخابز ",
      tag4: "المطابخ السحابية",
      sub1: "لا حاجة لتطبيق. ",
      sub2: "لا دفع معقد. ",
      sub3: "فقط قائمتك، رابطك، وواتساب.",
    },
  },
  compare: {
    title1: "لماذا تتحول الشركات إلى",
    titleAccent: "Meno",
    sub: "الطريقة القديمة لم تعد تنفع. إليك الطريقة الأفضل.",
    oldWay: "الطريقة القديمة",
    menoWayPrefix: "طريقة ",
    menoWaySuffix: "",
    ctaReady: "هل أنت مستعد للانتقال؟",
    ctaButton: "ابدأ الآن",
    old1: "دفع المزيد مقابل كل ميزة.",
    old2: "قوائم PDF ثقيلة يكرهها العملاء.",
    old3: "إعادة طباعة القوائم لتغيير سعر واحد.",
    old4: "إدارة قوائم مختلفة لكل فرع.",
    old5: "خسارة المبيعات لأن الطلب معقد.",
    new1: "رسم ثابت لكل موقع. جميع المميزات مفعّلة.",
    new2: "تجربة جميلة ومتوافقة مع الجوال.",
    new3: "حدّث الأسعار والعناصر فوراً، في أي وقت.",
    new4: "لوحة تحكم واحدة لإدارة جميع مواقعك.",
    new5: "الطلبات تصل مباشرة إلى واتساب.",
  },
  compareV2: {
    badge: "الفروقات",
    title1: "الطريقة القديمة، و",
    titleAccent: "طريقة Meno.",
    oldWay: "الطريقة القديمة",
    withMeno: "مع Meno",
    r1: {
      label: "عمولة على طلباتك",
      old: "نعم، على كل طلب",
      meno: "0%",
    },
    r2: {
      label: "استقبل الطلبات، لا تعرض فقط",
      old: "عرض فقط",
      meno: "مباشرة إلى واتساب",
    },
    r3: {
      label: "حدّث الأسعار فوراً",
      old: "إعادة طباعة / رفع",
      meno: "بنقرة واحدة",
    },
    r4: {
      label: "أدر عدة فروع من مكان واحد",
      old: "يدوياً ومعقد",
      meno: "لوحة تحكم واحدة",
    },
    r5: {
      label: "سعر مختلف لكل فرع",
      old: "غير متاح فعلياً",
      meno: "متاح",
    },
    r6: {
      label: "أنشئ كل صنف مرة واحدة",
      old: "إعادة إدخال في كل مرة",
      meno: "قائمة رئيسية",
    },
    r7: {
      label: "علامتك التجارية، لا علامتهم",
      old: "علامتهم هي الأقوى",
      meno: "علامتك بالكامل",
    },
    r8: {
      label: "يتطلب بوابة دفع",
      old: "إلزامي",
      meno: "غير مطلوب",
    },
    r9: {
      label: "يعمل في دقائق",
      old: "أيام من الإعداد",
      meno: "استيراد Excel",
    },
  },
  analytics: {
    badge: "تحليلات متقدمة",
    title: "افهم عملاءك",
    lead: "اعرف بالضبط من يطلب، من أين يأتي، وماذا يريد.",
    sub: "تحليلات لحظية لتحسين قائمتك وتنمية عملك.",
    f1: {
      title: "مراقبة المسح والزيارات",
      desc: "تتبع عدد مرات مسح رمز QR للفرع وزيارات روابط الفرع في الوقت الفعلي.",
    },
    f2: {
      title: "تحليلات جغرافية",
      desc: "اعرف البلدان والمدن التي يأتي منها عملاؤك لفهم مدى انتشارك.",
    },
    f3: {
      title: "تحليلات الجهاز والمنصة",
      desc: "افهم الأجهزة وأنظمة التشغيل واللغات التي يستخدمها عملاؤك.",
    },
    f4: {
      title: "تتبع مصادر الزيارات",
      desc: "حدد مصدر زياراتك: المسح المباشر، وسائل التواصل، وغير ذلك.",
    },
    statsQrScans: "2,240",
    statsLinkVisits: "1,220",
    qrScansLabel: "مسحات QR",
    linkVisitsLabel: "زيارات الرابط",
    visitorLocations: "مواقع الزوار",
    live: "مباشر",
    topItem: "أكثر صنف طلباً",
    topItemName: "تاكو حار",
    growth: "نمو 55%",
    liveTraffic: "تحليلات لحظية",
    mobile: "جوال",
    desktop: "سطح مكتب",
    dashboardAlt: "لوحة تحليلات Meno تعرض 2,240 مسح QR و1,220 زيارة رابط",
  },
  features: {
    title: "كل القوة. بدون أي تعقيد.",
    sub: "كل ما تحتاجه لإدارة قائمتك الرقمية باحترافية.",
  },
  f1: {
    badge: "إعداد سريع",
    title1: "ابدأ في دقائق،",
    title2: "وليس أيام.",
    desc: "وقتك ثمين. ارفع كامل كتالوجك عبر ملف Excel واحد — المنتجات، التصنيفات، والأسعار في مكان واحد. ثم خصّصه بإضافات وتنويعات وخيارات تسعير متقدمة عندما تكون جاهزاً. ستبدأ البيع قبل أن تبرد قهوتك.",
    tag1: "استيراد Excel",
    tag2: "مزامنة منصات التوصيل",
    tag3: "سحب وإفلات",
  },
  f2: {
    badge: "الفروع",
    title1: "سعر مخصص لكل فرع.",
    desc1:
      "أنشئ قائمة رئيسية، ثم عيّن المنتجات لأي فرع أو قائمة. حدّث الصور والأوصاف  أو الإضافات مرة واحدة، MENO يزامنها فوراً عبر كل المواقع.",
    desc2:
      "تحتاج أسعاراً مختلفة لكل فرع؟ حدّد تسعيراً مخصصاً لكل فرع دون تغيير السعر الأصلي.",
    tag1: "عناصر عامة",
    tag2: "قائمة حسب الموقع",
    tag3: "تسعير مخصص",
    loc1: "فرع وسط المدينة",
    loc2: "فرع المول",
    loc3: "فرع المطار",
    loc4: "كافيه الشاطئ",
    items: "عنصر",
    dashboardAlt: "لوحة تحكم متعددة المواقع تعرض 4 فروع مطعم",
  },
  f3: {
    badge: "طلبات إلى واتساب",
    title1: "اطلب عبر واتساب.",
    title2: "بدون ربط POS.",
    title3: "بدون بوابة دفع.",
    desc: "تجاوز حساب التاجر . استقبل الدفع نقداً عند الاستلام، أو بالبطاقة عبر جهاز POS الخاص بك عند الباب، أو أرسل رابط دفع، أنت تختار لكل موقع، والعميل يختار عند الدفع.",
    payLink: "رابط الدفع",
    payLinkDesc: "يرسل المطعم رابط دفع آمن بعد استلام الطلب.",
    payCash: "الدفع نقداً عند الاستلام",
    payCashDesc: "يدفع العميل نقداً عند وصول الطلب.",
    payCard: "الدفع بالبطاقة عند الاستلام",
    payCardDesc: "يدفع العميل بالبطاقة باستخدام جهاز نقاط البيع عند الباب.",
    note: "فعّل أو عطّل كل خيار دفع من لوحة التحكم. كل موقع يمكن أن يكون له إعداداته الخاصة.",
    note2: "اسأل عملاءك كيف يفضلون الدفع",
  },
  f4: {
    badge: "التخصيص",
    title: "علامتك التجارية، أسلوبك.",
    desc: "اضبط ألوان علامتك التجارية وصمّم صفحة المقدمة بشعارك وخلفيتك. ثم تحكّم بالكامل في رمز QR: خصّص الأنماط والألوان وموضع الشعار وكل التفاصيل. تصبح قائمتك امتداداً لعلامتك التجارية، لا قالباً عاماً بلا هوية.",
    qrTitle: "رمز QR مخصص",
    qrSub: "بشعارك وألوانك",
  },
  f5: {
    badge: "متعدد اللغات",
    title: "تحدث بلغتهم.",
    desc: "أضف ترجماتك الدقيقة بما يصل إلى 14 لغة عالمية. أنت تتحكم بالجودة. تسميات الحساسية تُترجم تلقائياً من مكتبتنا المعدة مسبقاً، ليبقى الجميع بأمان.",
  },
  products: {
    badge: "قائمة منتجات",
    title1: "مثالي لمنتجاتك",
    title2: "أيضاً.",
    desc: "MENO ليس للمطاعم فقط. استخدمه لإنشاء قائمة منتجات بسيطة لبائعي إنستغرام والمتاجر والفنانين والمشاريع المنزلية والمتاجر المؤقتة. أضف منتجاتك، شارك رابطك، واستقبل طلبات العملاء مباشرة على واتساب.",
    tag1: "بائعو إنستغرام",
    tag2: "المتاجر",
    tag3: "الفنانون",
    tag4: "المشاريع المنزلية",
    sub1: "لا حاجة لموقع كامل. ",
    sub2: "لا حاجة لتعقيدات الدفع. ",
    sub3: "فقط منتجاتك وواتساب.",
  },
  f6: {
    badge: "بدون عمولة",
    title1: "نأخذ 0% من طلباتك. دوماً.",
    desc: "منصات التوصيل تأخذ نسبة من كل طلب. Meno لا يأخذ عمولة أبداً. تدفع رسماً ثابتاً لكل موقع شهرياً أو سنوياً وتحتفظ بـ 100% من كل عملية بيع.  عشرة طلبات أو عشرة آلاف: فاتورة Meno لا تتغير.",
    tag1: "بدون عمولة لكل طلب",
    tag2: "بدون رسوم لكل مسح",
    tag3: "بدون ميزات مدفوعة",
    tag4: "كل المميزات في خطة واحدة.",
    commission: "عمولة",
    commissionAriaLabel: "عدّاد تنازلي للعمولة من ٣٠% إلى ٠%",
  },
  brandLook: {
    badge: "علامتك، مظهرك",
    title1: "قائمة تحمل",
    titleAccent: "هويتك",
    desc: "ارفع شعارك، حدّد لون علامتك، واختر صورة غلاف أو لوناً، قائمتك تحمل هويتك من البداية للنهاية. ثم انشرها للعالم: ترجم قائمتك إلى 14 لغة، واختر اللغات التي يقدّمها كل موقع.",
    brandColorLabel: "لون العلامة",
    brandColorHint: "اضغط للمعاينة",
    menuLanguageLabel: "لغة القائمة",
  },
  richItems: {
    badge: "منتجات جاهزة للبيع",
    title1: "منتجات تستحق الضغط على",
    titleAccent: "إضافة",
    title2: ".",
    desc: "كل منتج هو صفحة كاملة، وليس سطراً في قائمة.",
    f1: {
      title: "صور وفيديو",
      desc: "أول صورة تصبح الغلاف.",
    },
    f2: {
      title: "خيارات",
      desc: "أحجام وخيارات، لكل منها سعره الخاص.",
    },
    f3: {
      title: "إضافات وخيارات إلزامية",
      desc: '"اختر صلصة" أو "أضف إضافات"، كل منها بسعر.',
    },
    f4: {
      title: "تسعير التخفيضات",
      desc: "اشطب السعر القديم؛ يظهر الخصم تلقائياً.",
    },
    f5: {
      title: "اقتراحات مكمّلة",
      desc: "اقترح جانباً أو مشروباً لرفع قيمة كل طلب.",
    },
    f6: {
      title: "سعرات، مسببات حساسية ورمز SKU",
      desc: "مواصفات مدمجة، مع عدد الطلبات لكل عنصر.",
    },
    mockup: {
      photoCount: "١/٣ صور",
      productName: "طبق مشاوي",
      description: "لحم مدخن، مطبوخ ببطء، مع صلصة البيت.",
      calories: "٨٢٠ سعرة",
      allergens: "غلوتين، ألبان",
      variation: "الخيارات",
      regular: "عادي · ٥٠$",
      large: "كبير · ٧٢$",
      chooseSauce: "اختر صلصة ·",
      required: "إلزامي",
      greenSauce: "صلصة خضراء",
      smokyBbq: "باربكيو مدخن",
      add: "إضافة · ٥٠.٠٠$",
    },
  },
  teamRoles: {
    badge: "الفريق والأدوار",
    title1: "إدارة كل فرع بـ",
    titleAccent: "الأيدي المناسبة.",
    desc: "أضف فريقك إلى مساحة العمل وامنح كل شخص الوصول الذي يحتاجه بالضبط، ليدير المدراء فرعهم وينفّذ الموظفون الطلبات، دون الوصول إلى أي شيء آخر.",
    cardAria: "معاينة إدارة أعضاء الفريق",
    cardTitle: "أعضاء الفريق",
    cardWorkspace: "مساحة العمل: مطعم ACME",
    inviteButton: "+ دعوة مستخدم",
    colUser: "المستخدم",
    colRole: "الدور",
    emailPlaceholder: "أدخل البريد الإلكتروني",
    roles: {
      admin: {
        title: "مسؤول",
        desc: "وصول كامل لمساحة العمل: القائمة، الفروع، العلامة التجارية والفريق.",
      },
      manager: {
        title: "مدير الفرع",
        desc: "إدارة القوائم والأسعار وساعات العمل والطلبات للفروع المُعيَّنة له.",
      },
      operator: {
        title: "مشغّل الفرع",
        desc: "استقبال وتنفيذ طلبات واتساب الواردة في فرعه، لا أكثر.",
      },
    },
    members: {
      owner: {
        initials: "DS",
        name: "Dexter Snow",
        handle: "@dextersnow",
        role: "المالك",
      },
      manager: {
        initials: "JD",
        name: "John Doe",
        handle: "@johndoe · فرع ميامي",
        role: "مدير الفرع",
      },
      operator: {
        initials: "AK",
        name: "Aamir Khan",
        handle: "@aamirkhan · الفرع الرئيسي — نيويورك",
        role: "مشغّل الفرع",
      },
    },
  },
  how: {
    title: "ابدأ في دقائق، وليس أيام.",
    sub: "ثلاث خطوات. هذا كل ما يتطلبه الأمر.",
    step: "الخطوة",
    s1: {
      title: "أنشئ مساحة عملك",
      desc: "أنشئ مساحة عمل Meno في ثوانٍ. أضف تفاصيل عملك وادعُ فريقك.",
    },
    s2: {
      title: "ابنِ قائمتك",
      desc: "أضف المنتجات، أنشئ التصنيفات، ارفع الصور، ونظّم كل شيء كما تريد.",
    },
    s3: {
      title: "أنشئ وابدأ الخدمة",
      desc: "حمّل رموز QR المخصصة، شارك رابطك، وشاهد الطلبات تتوالى. انتهى.",
    },
  },
  menoSteps: {
    title1: "من الصفر إلى استقبال الطلبات،",
    title2: "اليوم.",
    sub: "كل ما تحتاجه لإدارة قائمتك الرقمية باحترافية.",
    steps: {
      s1: {
        headline: "أضف منتجاتك مرة واحدة",
        subheading: "اجعل قائمتك جاهزة خلال دقائق.",
        bullets: [
          "أضف أسماء المنتجات والصور أو الفيديوهات والأسعار والإضافات.",
          "استورد كل شيء من ملف Excel واحد أو أدخل المنتجات يدوياً.",
          "كل منتج يُنشأ مرة واحدة فقط.",
        ],
        imageAlt: "أضف منتجاتك مرة واحدة",
      },
      s2: {
        headline: "أنشئ فروعك وقوائمك.",
        subheading: "تحكّم ب قائمتك من لوحة تحكم واحدة.",
        bullets: [
          "أنشئ موقعاً لكل فرع أو متجر.",
          "اختر العناصر التي تظهر في قائمة كل فرع.",
          "حدّد أسعاراً مختلفة لكل فرع، مع صفحة ورمز QR فريد.",
        ],
        imageAlt: "خصّص وأدر",
      },
      s3: {
        headline: "شاركها واستقبل الطلبات.",
        subheading: "رابط قائمة واحد. رابط طلب واحد. تحليلات واضحة.",
        bullets: [
          "شارك قائمتك برابط واحد أو رمز QR من تصميمك في أي مكان.",
          "يتصفح العميل، يضيف المنتجات إلى السلة، ويرسل طلبه مباشرة عبر رابط طلب واحد واضح.",
          "تتبع الأداء بالتحليلات والتقارير ومراجعات العملاء على أصنافك.",
        ],
        imageAlt: "شارك واستقبل الطلبات",
      },
    },
  },
  pricingV2: {
    badge: "الأسعار",
    title1: "خطة واحدة. كل شيء مضمّن.",
    titleAccent: "بدون عمولة.",
    sub: "لا عمولة، لا رسوم لكل مسح، لا ميزات مدفوعة، كل ميزة أدناه مضمّنة. ادفع رسماً ثابتاً لكل موقع وأضف فروعاً فقط عند الحاجة.",
    pro: "PRO",
    priceYearly: "$24",
    priceMonthly: "$29",
    perMonth: "/شهر",
    priceYearlyNote: "شهرياً، يُدفع سنوياً ($290/سنة)",
    priceMonthlyNote: "يُدفع شهرياً",
    saveBadge: "شهران مجاناً",
    basePlan: "الخطة الأساسية تشمل فرعاً واحداً",
    outletsTitle: "أضف فروعاً عند الحاجة",
    outlet1_10: "1-10 فروع",
    outlet11plus: "11+ فرع",
    outlet1_10AmountYearly: "$15",
    outlet1_10AmountMonthly: "$18",
    outlet11plusAmountYearly: "$12",
    outlet11plusAmountMonthly: "$14",
    outletPriceUnit: "/فرع · شهر",
    commissionNote:
      "0% عمولة على كل طلب، ادفع فقط مقابل الفروع التي تديرها فعلياً.",
    trialTitle: "تجربة مجانية 30 يوماً",
    trialDesc: "جرّب كل المميزات.",
    cta: "ابدأ تجربتك المجانية لمدة 30 يوماً",
    featuresTitle: "كل شيء مضمّن",
    featuresBadge: "كل الخطط",
  },
  pricing: {
    unbeatable_value: "قيمة لا تُضاهى لكل موقع",
    monthly: "شهري",
    yearly: "سنوي",
    save_badge: "وفّر 40%",
    title: "تسعير بسيط وشفاف.",
    sub: "لا رسوم خفية. لا قيود على المميزات. لا رسوم لكل مسح. تحصل على كل ميزة من اليوم الأول.",
    badge: "جميع المميزات مفعّلة",
    flat: "رسم ثابت لكل موقع. كل شيء مفتوح.",
    price_label: "الخطة الأساسية تشمل (فرع واحد)",
    additional_outlets: "فروع إضافية",
    outlet_1_10: "(1-10)",
    outlet_11_plus: "(11+)",
    f1: "عناصر وتصنيفات غير محدودة",
    f2: "ترجمة إلى 14 لغة",
    f3: "طلب عبر واتساب",
    f4: "تسعير وتنويعات مخصصة",
    f5: "رموز QR مخصصة بعلامتك",
    f6: "تنويعات، إضافات واقتراحات المنتجات",
    f7: "إدارة أعضاء الفريق",
    f8: "استيراد Excel",
    f9: "إدارة الطلبات",
    f10: "تحليلات كاملة لكل موقع: البلد، الجهاز، المصدر، والمزيد",
    cta: "ابدأ تجربتك المجانية لمدة 30 يوم",
    noCc: "لا حاجة لبطاقة ائتمان.",
  },
  qrhub: {
    title: "تستخدم QRHUB؟",
    desc: "انتقل بين مساحات عمل QRHUB و Meno من نفس الحساب. أنشئ مساحة عمل Meno فوراً وابدأ البيع.",
    cta: "اذهب إلى لوحة التحكم",
  },
  needHelp: {
    badge: "الدعم",
    title: "كيف يمكننا مساعدتك؟",
    desc: "سواء كنت تبدأ مع Meno، أو تحتاج دعماً تقنياً، أو لديك استفسار شراكة، فريقنا جاهز لمساعدتك.",
    cta: "تواصل معنا",
  },
  faq: {
    badge: "الأسئلة الشائعة",
    title1: "أسئلة،",
    titleAccent: "بإجابات.",
    sub: "كل ما يسأله صاحب العمل غير التقني قبل الإطلاق.",
    title: "لديك أسئلة؟",
    q1: "هل Meno للمطاعم فقط؟",
    a1: "أبداً. Meno مثالي للمطاعم، لكنه مصمم لأي عمل يحتاج طريقة بسيطة لعرض المنتجات واستقبال الطلبات. بائعو إنستغرام، الخبازون المنزليون، الفنانون، المتاجر المؤقتة إذا لديك شيء تبيعه، Meno يناسبك.",
    q2: "كيف يعمل التسعير؟",
    a2: "بسيط. تدفع رسماً ثابتاً لكل موقع تديره. هذا الرسم يفتح 100% من مميزات Meno. لا باقات مميزة، لا عروض ترقية، لا مفاجآت.",
    q3: "هل يمكنني وضع أسعار مختلفة لنفس العنصر في مواقع مختلفة؟",
    a3: "نعم. Meno يتيح لك تحديد سعر افتراضي للعنصر ثم تعديله بأسعار مخصصة لمواقع محددة. لا حاجة لتكرار العناصر.",
    q4: "كيف يعمل الطلب عبر واتساب؟",
    a4: "العملاء يتصفحون قائمتك، يضيفون العناصر إلى السلة، ويختارون طريقة الدفع (رابط دفع، نقداً، أو بطاقة). عند الإرسال، يُرسل طلبهم الكامل مباشرة إلى واتساب كرابط. تستلم طلباً منظماً بكل التفاصيل.",
    q5: "هل أحتاج موقع إلكتروني أو نظام POS؟",
    a5: "أبداً. Meno يمكن أن يكون نظام الطلب الإلكتروني البسيط والقوي. تستلم الطلب من واتساب وتعالجه يدوياً. لا حاجة للربط مع نظام ال POS.",
    q6: "كم يستغرق البدء؟",
    a6: "إذا لديك قائمة منتجاتك في ملف Excel، يمكنك أن تكون جاهزاً قبل أن تبرد قهوتك. جدياً. ارفع ملفك، خصّص مظهرك، أنشئ رمز QR، وانطلق.",
  },
  cta: {
    title1: "توقف عن عرض قائمتك. ",
    title2: "ابدأ البيع من خلالها.",
    sub: "انشئها مرة واحدة، خصّصها بعلامتك، واستقبل الطلبات على واتساب بدون عمولة.",
    button: "ابدأ تجربتك المجانية لمدة 30 يوماً",
    buttonSecondary: "طريقة العمل",
    trial: "تجربة مجانية 30 يوم · 0% عمولة",
  },
  footer: {
    byQrhub: "من QRHUB",
    rights: "QRHUB. جميع الحقوق محفوظة.",
  },
  seo: {
    menoDigitalMenu: {
      title: "Meno - قائمة رقمية تحقق طلبات فعلية",
      description:
        "أنشئ قائمة منتجات تفاعلية، أدر فروعك بسهولة، واستقبل طلبات العملاء مباشرة عبر واتساب.",
      keywords:
        "قائمة رقمية, طلب عبر واتساب, قائمة مطعم, طلب عبر الإنترنت, إدارة قائمة متعددة المواقع, تحقق طلبات فعلية",
      ogDescription:
        "أنشئ قائمة منتجات تفاعلية، أدر فروعك بسهولة، واستقبل طلبات العملاء مباشرة عبر واتساب.",
    },
  },
};

export default ar;
